__turbopack_context__.v({
  "grid-logo": "client-logo-grid-module__YwAuyG__grid-logo",
});
